import { createSlice } from "@reduxjs/toolkit";
import { decodeToken } from "react-jwt";

const storedAccessToken = typeof window !== 'undefined' ? window.localStorage.getItem('accessToken') : null;

const initialState = {
    user:  storedAccessToken ? decodeToken(storedAccessToken) : null
}

export const authSlice = createSlice({
    name: "Auth",
    initialState,
    reducers: {
        logIn: (state, action) => {
            state.user = action.payload;
        }
    },
}) 

export const { logIn } = authSlice.actions;
export default authSlice.reducer;